<template>

    <h1 class="mb-6 text-theme-main">Hello. I am a VUE Component, called via Vue Router link, this time from the Sidebar Menu.</h1>

</template>

<script>

    export default {
        mounted() {
            /*console.log('The TEST component was mounted.');*/
            // Event.fire('closeSidebar');
        },
    }

</script>
